<div
  [ngClass]="{
    regular: stylingClass === 'regular',
    light: stylingClass === 'light',
    compact: compactVersion,
    'large-font': largeFont,
  }"
>
  @if (amount) {
    @if (compactVersion) {
      @if (amount.total) {
        {{ amount.total | compactAmount }}
      } @else if (amount.min) {
        {{ amount.min | compactAmount }} (min.)
        {{ amount.max ? ' - ' + (amount.max | compactAmount) + ' (max.)' : '' }}
      } @else if (amount.max) {
        {{ amount.max | compactAmount }} (max.)
      } @else {
        <ng-container [ngTemplateOutlet]="undetected" [ngTemplateOutletContext]="{ variant: '-short' }"></ng-container>
      }
    } @else {
      @if (amount.total) {
        {{ amount.total | currency: 'EUR' : 'symbol' : '.0' : 'fr' }}
      } @else if (amount.min) {
        {{ amount.min | currency: 'EUR' : 'symbol' : '.0' : 'fr' }} (min.)
        {{ amount.max ? ' - ' + (amount.max | currency: 'EUR' : 'symbol' : '.0' : 'fr') + ' (max.)' : '' }}
      } @else if (amount.max) {
        {{ amount.max | currency: 'EUR' : 'symbol' : '.0' : 'fr' }} (max.)
      } @else {
        <ng-container [ngTemplateOutlet]="undetected" [ngTemplateOutletContext]="{ variant: '-short' }"></ng-container>
      }
    }
  } @else {
    <ng-container [ngTemplateOutlet]="undetected" [ngTemplateOutletContext]="{ variant: '-short' }"></ng-container>
  }
</div>

<ng-template #undetected let-variant="variant">
  <span class="undetected-message fst-italic">{{ 'tenders.' + undetectedTranslationKey + variant | translate }}</span>
</ng-template>
